import React, {Component, PropTypes} from 'react'
import {Panel} from 'react-bootstrap'
import DefineUpdateInterventionPeriodForActivityForm from './DefineUpdateInterventionPeriodForActivityForm'

class DefineInterventionPeriodPanel extends Component {
    static propTypes = {
        committed: PropTypes.object.isRequired,
        activity: PropTypes.object.isRequired,
        interventionPeriods: PropTypes.array.isRequired
    }

    render() {
        const {committed, activity, interventionPeriods, bsStyle, onSelect, ...others} = this.props

        return (
            <Panel
                onSelect={onSelect}
                {...others}>
                <DefineUpdateInterventionPeriodForActivityForm
                    committed={committed}
                    activity={activity}
                    interventionPeriods={interventionPeriods}
                    onSubmit={(e, r, i) => onSelect(e, i)} />
            </Panel>
        )
    }
}

export default DefineInterventionPeriodPanel


// WEBPACK FOOTER //
// ./lib/provider/components/DefineInterventionPeriodPanel.js